/* eslint-disable max-len */
// @flow
import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import { connect } from 'react-redux';
import Lock from 'assets/imgs/lock.svg';
import {
  Input,
  Select,
  Icon,
  Modal,
  Row,
  Col,
  Tooltip,
  // AutoComplete,
} from 'antd';
import ReactSelect from 'react-select';
import moment from 'moment-timezone';
import SimpleReactValidator from 'simple-react-validator';
import {
  MESSAGES,
  BENE_TYPES,
} from 'appconstants';
import {
  validationRegex,
  validators,
} from 'utils/validationMessages';
import {
  SpH5, SpError, SpButton, SpText,
} from 'components/DesignKit';
import {
  manageAccountActions, notificationActions, transfersActions, vendorInvoiceDetailsActions,
} from 'store/actions';
import formatAmount from 'utils/formatAmount';
import { API_END_POINTS, axiosAuthInstance } from 'api';
import IndividualIcon from 'assets/imgs/Individual_icon.png';
import BusinessIcon from 'assets/imgs/Business_icon.png';
import AccountVerifiedIcon from 'assets/imgs/account-verified-badge.png';
import EnabledBadge from 'components/NavIcons/enabledBadge';
import OTPInput from 'react-otp-input';
import { NOTIFICATION } from 'store/actionTypes';
import { informationIcon } from 'components/NavIcons';
import debounce from 'lodash.debounce';
import BankLogo from './BankLogo';
// import { invoice } from 'components/NavIcons';

const { Option } = Select;

const MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

type Props = {
  isIndia: boolean,
  visible: boolean,
  transferDetailsData: Object,
  selectedAccount: Object,
  close: Function,
  invoiceDetails: Object,
  invoiceFundingSourceName: String,
  fetchVendorInvoiceDetails: Function,
  searchFundingSource: Function,
  fundingSearchList: Array<Object>,
  manageAccountsList: Array<Object>,
  fetchSelfAccounts: Function,
  setNotification: Function,
  submit: Function,
  isCrossBorder: Boolean,
};

const ConfirmationPaymentModal = (props: Props) => {
  const {
    searchFundingSource,
    invoiceFundingSourceName,
    manageAccountsList,
    fetchSelfAccounts,
    fundingSearchList,
    invoiceDetails,
    isIndia,
    transferDetailsData,
    selectedAccount,
    visible,
    close,
    setNotification,
    fetchVendorInvoiceDetails,
    submit,
    isCrossBorder,
  } = props;

  const [, forceUpdate] = useState();
  const [manageAccountInfo, setManageAccountInfo] = useState(manageAccountsList);
  const [contactName, setContactName] = useState('');
  const [payerFundingSourceGid, setPayerFundingSourceGid] = useState('');
  const [payerFundingSourceBankInfo, setPayerFundingSourceBankInfo] = useState({});
  const [fundingSourceName, setFundingSourceName] = useState(invoiceFundingSourceName);
  const [fundingSourceGid, setFundingSourceGid] = useState();
  const [fundingSourceBankInfo, setFundingSourceBankInfo] = useState({});
  const [accountNumber, setAccountNumber] = useState();
  const [routingNumber, setRoutingNumber] = useState();
  const [accountType, setAccountType] = useState(isIndia ? 'CURRENT' : 'CHECKING');
  const [businessType, setBusinessType] = useState('INDIVIDUAL');
  const [bankName, setBankName] = useState();
  const [transferSettings, setTransfersetting] = useState({});
  const [upiId, setUpiId] = useState();
  const [accountHolderName, setAccountHolderName] = useState();
  const [fundingResult, setFundingResult] = useState([]);
  const [disableFunding, setDisableFunding] = useState();
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [otp, setOtp] = useState();
  const [UniqueIdOtp, setUniqueIdOtp] = useState('');
  const [otpVerifyLoading, setOtpVerifyLoading] = useState(false);
  const [fundingSourceNewSuccess, setAddFundingSourceNewSuccess] = useState(false);
  const [error, setError] = useState(false);
  const accountRegex = /[0-9]{6,17}/;
  const routingRegex = /[0-9]{9}/;
  const upiRegex = /^\w.+@\w+$/;
  const transferType = (isIndia ? 'IMPS' : 'ACH');
  const countryCode = selectedAccount.country.alpha2;
  const { prefix } = selectedAccount && selectedAccount.currency;
  const currencyType = selectedAccount && selectedAccount.currency;
  const totalAmount = formatAmount((invoiceDetails && (invoiceDetails.total ? invoiceDetails.total / 100 : invoiceDetails.amount / 100)), currencyType);
  const [exchangeEntity, setExchangeEntity] = useState({});
  const [exchangeFee, setexchangeFee] = useState(0);
  const [convertedAmount, setConvertedAmount] = useState(0);
  const [exchangeRate, setExchangeRate] = useState(0);
  const [tax, setTax] = useState(0);
  const [lowVolumeFee, setLowVolumeFee] = useState(0);
  const [totalFee, setTotalFee] = useState(0);
  const debouncedFetchSelfAccounts = debounce(fetchSelfAccounts, 2000, { leading: true });

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      accountNumber: {
        message: MESSAGES.BANK_DETAILS.VALID,
        rule: val => accountRegex.test(val),
      },
      bankRoutingNumber: {
        message: MESSAGES.BANK_DETAILS.ROUTING,
        rule: val => routingRegex.test(val),
      },
      bankName: {
        message: validators.bussiness.validBankName,
        rule: val => validationRegex.nameRegex.test(val),
      },
      upiNumber: {
        message: MESSAGES.BANK_DETAILS.UPI,
        rule: val => upiRegex.test(val),
      },
    },
  }));

  simpleValidator.current.purgeFields();

  const getTransferSetting = async () => {
    try {
      const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.TRANSFER_SETTING}`);
      setTransfersetting(entity);
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response.data && e.response.data.message,
      });
    }
  };

  const getExchangeRatesList = async (params) => {
    try {
      const { data: { entity: { content } } } = await axiosAuthInstance.get(`${API_END_POINTS.EXCHANGE_RATE_LIST}?${params}`);
      const exchangeGid = content?.[0]?.gid;
      if (exchangeGid && invoiceDetails?.amount) {
        const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.EXCHANGE_RATE_SPLITUP}/${exchangeGid}?amount=${invoiceDetails?.total ? invoiceDetails?.total : invoiceDetails?.amount}&transferTypeCode=ACH`);
        setExchangeEntity(entity || {});
        const exchFee = formatAmount(entity?.feeAmount ? (typeof entity?.feeAmount === 'number' && entity?.feeAmount / 100) : 0, currencyType);
        setexchangeFee(exchFee);
        setTax(entity?.feeTax ? formatAmount((typeof entity?.feeTax === 'number' && entity?.feeTax / 100), currencyType) : 0);
        setConvertedAmount(entity?.convertedAmount ? formatAmount((typeof entity?.convertedAmount === 'number' && entity?.convertedAmount / 100), currencyType) : 0);
        setExchangeRate(typeof entity?.exchangeRate === 'number' && entity?.exchangeRate);
        setLowVolumeFee(entity?.lowVolumeFee ? formatAmount((typeof entity?.lowVolumeFee === 'number' && entity?.lowVolumeFee / 100), currencyType) : 0);
        if (entity?.feeAmount || entity?.lowVolumeFee || entity?.feeTax) {
          setTotalFee(formatAmount((((typeof entity?.feeAmount === 'number' && entity?.feeAmount) || 0) + ((typeof entity?.lowVolumeFee === 'number' && entity?.lowVolumeFee) || 0) + ((typeof entity?.feeTax === 'number' && entity?.feeTax) || 0)) / 100, currencyType));
        }
      } else if (isCrossBorder) {
        setNotification({
          type: NOTIFICATION.ERROR,
          payload: 'Exchange Rate not available for the Date',
        });
        close();
      }
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  };

  useEffect(() => {
    const { fundingSource, contact } = invoiceDetails || {};
    if (fundingSource?.gid) {
      setFundingSourceGid(fundingSource.gid);
    }
    if (contact?.gid) {
      searchFundingSource(`page=1&size=100&issuerBank.routingNumber.NOTNULL=true&contact.gid.EQ=${contact.gid}`);
    }
    if (contact) {
      const currentPage = 1;
      const sortBy = 'createdAt';
      const direction = 'DESC';
      const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
      const filterParam = '&issuerBank.routingNumber.NOTNULL=true';
      const size = 1000;
      debouncedFetchSelfAccounts({
        currentPage, sortParams, filterParam, size,
      });
      getTransferSetting();
    }
    if (invoiceDetails?.transferType?.value === 'ACH' && fundingSource?.issuerBank?.country?.alpha2 === 'IN') {
      const today = moment();
      const Date = moment(today.toDate()).utc().format(MOMENT_FORMAT);
      const selectedDateForExchange = moment.tz(Date, 'UTC');
      const utcExchangeRate = selectedDateForExchange.utc().format(MOMENT_FORMAT);
      const exchangeRateParams = `date=${utcExchangeRate}&fromCurrency.EQ=USD&toCurrency.EQ=INR&status.EQ=ACTIVE`;
      getExchangeRatesList(exchangeRateParams);
    }
  }, [invoiceDetails]);

  useEffect(() => {
    if (!fundingSearchList || fundingSearchList.length === 0) return;
    const result = fundingSearchList.find((item) => item.gid === invoiceDetails.fundingSource.gid);
    setFundingSourceBankInfo(() => (
      {
        issuerBank: result?.issuerBank,
        contactName: result?.contact.name,
      }
    ));
  }, [invoiceDetails, fundingSearchList]);


  useEffect(() => {
    if (manageAccountsList && manageAccountsList.length > 0) {
      setManageAccountInfo(manageAccountsList);
      const primaryContact = manageAccountsList.filter((item) => (item?.contact?.primary));
      if (primaryContact.length > 0 && primaryContact?.[0]?.gid) {
        setContactName(
          primaryContact[0]?.issuerBank?.bankName && primaryContact[0]?.issuerBank?.lastFour
            ? `${primaryContact[0]?.issuerBank?.bankName} **** ${primaryContact[0]?.issuerBank?.lastFour}`
            : '',
        );
        setPayerFundingSourceGid(primaryContact?.[0]?.gid);
        setPayerFundingSourceBankInfo(() => (
          {
            bankName: primaryContact[0]?.issuerBank?.bankName,
            lastFour: primaryContact[0]?.issuerBank?.lastFour,
            primaryBankStatus: primaryContact[0]?.contact?.primary,
            contactName: primaryContact[0]?.contact?.name,
          }
        ));
      }
    }
  }, [manageAccountsList]);

  useEffect(() => {
    if (fundingSearchList && fundingSearchList.length > 0) setFundingResult(fundingSearchList);
  }, [fundingSearchList]);

  const updateFunding = (value) => {
    if (value.label === 'New Funding Source') {
      setDisableFunding(false);
      setFundingSourceName('New Funding Source');
      setAccountNumber('');
      setRoutingNumber('');
      setAccountType(countryCode === 'IN' ? 'CURRENT' : 'CHECKING');
      setBusinessType('INDIVIDUAL');
      setBankName('');
      setAccountHolderName('');
      setUpiId('');
    } else if (value.value) {
      setFundingSourceName(value.value);
      const results = fundingResult.filter((item) => (item.gid === value.value));
      if (results && results[0].gid) {
        setFundingSourceGid(results && results[0].gid);
        if (results && results[0].issuerBank) {
          let fundName;
          if (results && results[0].issuerBank) {
            if ((results[0].contact.name) && (results[0].issuerBank.bankName) && (results[0].issuerBank.lastFour)) {
              fundName = `${results[0].contact.name} | ${results[0].issuerBank.bankName} ****${results[0].issuerBank.lastFour}`;
            } else if ((results[0].issuerBank.bankName) && (results[0].issuerBank.lastFour)) {
              fundName = `${results[0].issuerBank.bankName} ****${results[0].issuerBank.lastFour}`;
            } else if ((results[0].issuerBank.vpa)) {
              fundName = results[0].issuerBank.vpa;
            } else if ((results[0].issuerBank.bankName)) {
              fundName = results[0].issuerBank.bankName;
            } else if ((results[0].issuerBank.lastFour)) {
              fundName = `****${results[0].issuerBank.lastFour}`;
            }
          }
          setFundingSourceName(fundName);
          setUpiId(results[0].issuerBank && results[0].issuerBank.vpa);
          setAccountNumber(results[0].issuerBank && results[0].issuerBank.lastFour);
          setAccountHolderName(results[0].issuerBank && results[0].issuerBank.accountHolderName);
          setRoutingNumber(results[0].issuerBank && results[0].issuerBank.routingNumber);
          setAccountType(results[0].issuerBank && results[0].issuerBank.accountType);
          setBusinessType((results[0].issuerBank && results[0].issuerBank.businessType) || 'INDIVIDUAL');
          setBankName(results[0].issuerBank && results[0].issuerBank.bankName);
          setFundingSourceBankInfo(() => (
            {
              issuerBank: results[0]?.issuerBank,
              contactName: results[0]?.contact.name,
            }
          ));
        }
        setDisableFunding(true);
      }
    }
  };

  const getOtpUniqueId = async () => {
    try {
      setOtpVerifyLoading(true);
      const { data: { entity: { uniqueId } } } = await axiosAuthInstance.post(API_END_POINTS.TRANSFER_OTP);
      setUniqueIdOtp(uniqueId);
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
      });
    } finally {
      setOtpVerifyLoading(false);
    }
  };

  const handleOtp = async () => {
    if (!UniqueIdOtp) {
      getOtpUniqueId();
      setShowOtpScreen(true);
      return;
    }
    if (UniqueIdOtp && !otp) {
      setError(true);
      return;
    }
    // Api calls are done here to avoid loading and closing of modal and enterotp validation
    if (UniqueIdOtp && otp) {
      setError(false);
      let params;
      if (exchangeEntity && exchangeEntity?.exchangeRateGid) {
        params = {
          payerFundingSourceGid, fundingSourceGid, swirepayOtpGid: UniqueIdOtp, otpCode: otp, exchangeRateGid: exchangeEntity?.exchangeRateGid, convertedCurrencyCode: 'INR',
        };
      } else {
        params = {
          payerFundingSourceGid, fundingSourceGid, swirepayOtpGid: UniqueIdOtp, otpCode: otp,
        };
      }
      try {
        setOtpVerifyLoading(true);
        await axiosAuthInstance.patch(`${API_END_POINTS.VENDORINVOICE_API}/${invoiceDetails?.gid}/pay`, params);
        await fetchVendorInvoiceDetails(invoiceDetails?.gid);
      } catch (e) {
        setNotification({
          type: NOTIFICATION.ERROR,
          payload: e.response ? e.response.data.message : MESSAGES.API_ERROR,
        });
      } finally {
        setOtpVerifyLoading(false);
      }
    }
  };

  const handlePay = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const approveLimt = (transferSettings && transferSettings.minApprovalLimit);
    const requiresOtp = (Number(invoiceDetails?.amount) > approveLimt) && !selectedAccount.issuer.requiresOtp;
    if (requiresOtp && fundingSourceName !== 'New Funding Source') {
      handleOtp();
    }
    if (fundingSourceName === 'New Funding Source') {
      const contactGid = invoiceDetails?.contact?.gid;
      let fundingSourceAddGid;
      let issuerBank;
      if (transferType === BENE_TYPES.UPI) {
        issuerBank = {
          beneType: BENE_TYPES.VPA,
          vpa: upiId,
          countryCode: selectedAccount.country.alpha2,
        };
      } else {
        issuerBank = {
          accountNumber,
          routingNumber,
          accountType,
          businessType,
          bankName,
          fundingSourceName,
          beneType: BENE_TYPES.BANK,
          countryCode: selectedAccount.country.alpha2,
          accountHolderName,
        };
      }
      const fundingObject = {
        contactGid,
        issuerBank,
      };
      if (!fundingSourceNewSuccess) {
        try {
          const { data: { entity: { gid } } } = await axiosAuthInstance.post(API_END_POINTS.GET_FUNDINGSOURCE, fundingObject);
          fundingSourceAddGid = gid;
          setFundingSourceGid(gid);
          setAddFundingSourceNewSuccess(true);
          setNotification({
            type: NOTIFICATION.SUCCESS,
            payload: MESSAGES.FUNDINGSOURCE.ADD_SUCCESS,
          });
        } catch (e) {
          setNotification({
            type: NOTIFICATION.ERROR,
            payload: e.response.data && e.response.data.message,
          });
        }
      }
      if (requiresOtp) {
        handleOtp();
      }
      if (!requiresOtp) {
        if (exchangeEntity && exchangeEntity?.exchangeRateGid) {
          submit({
            payerFundingSourceGid, fundingSourceGid: fundingSourceAddGid, exchangeRateGid: exchangeEntity?.exchangeRateGid, convertedCurrencyCode: 'INR',
          });
        } else {
          submit({ payerFundingSourceGid, fundingSourceGid: fundingSourceAddGid });
        }
      }
    } else if (!requiresOtp) {
      if (exchangeEntity && exchangeEntity?.exchangeRateGid) {
        submit({
          payerFundingSourceGid, fundingSourceGid, exchangeRateGid: exchangeEntity?.exchangeRateGid, convertedCurrencyCode: 'INR',
        });
      } else {
        submit({ payerFundingSourceGid, fundingSourceGid });
      }
    }
  };
  // const searchContact = (val) => {
  //   if (val) {
  //     const testArray = manageAccountsList.filter((item) => (item.issuerBank.bankName.toLowerCase()).includes(val.toLowerCase()));
  //     setManageAccountInfo(testArray);
  //   } else {
  //     setManageAccountInfo(manageAccountsList);
  //   }
  // };

  const updateContact = (value) => {
    const results = manageAccountsList.filter((item) => (item.gid === value.value));
    if (results && results[0].gid) {
      setContactName(`${results[0].issuerBank.bankName} **** ${results[0].issuerBank.lastFour}`);
      setPayerFundingSourceGid(results[0].gid);
      setPayerFundingSourceBankInfo(() => (
        {
          bankName: results[0]?.issuerBank?.bankName,
          lastFour: results[0]?.issuerBank?.lastFour,
          primaryBankStatus: results[0]?.contact?.primary,
          contactName: results[0]?.contact?.name,
        }
      ));
    }
  };

  const reactContactOptions = manageAccountInfo.map((item) => {
    const bankInfo = `${item?.contact.name} ${item?.issuerBank.bankName} ${item?.issuerBank.lastFour}`;
    const displayDetails = item?.contact?.primary ? `${bankInfo} (Primary)` : bankInfo;
    return {
      label: displayDetails,
      value: item?.gid,
      issuerBank: item?.issuerBank,
      primaryBankStatus: item?.contact?.primary,
      contactName: item?.contact?.name,
    };
  });

  const selectFieldCustomOptions = (dataProps) => {
    const {
      data,
      innerRef,
      innerProps,
    } = dataProps;
    const { issuerBank, primaryBankStatus, contactName: selectOptionContactName } = data;
    const rtpSupportedIcon = (issuerBank?.rtpsupported !== null && issuerBank?.rtpsupported)
      ? <EnabledBadge style={{ marginLeft: '5px' }} />
      : null;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          display: 'flex', alignItems: 'center', padding: '10px', maxHeight: '50px',
        }}
      >
        {selectOptionContactName} | <BankLogo bankName={issuerBank.bankName} /> **** {issuerBank.lastFour} {primaryBankStatus ? '(Primary)' : ''} {rtpSupportedIcon}
      </div>
    );
  };

  const selectFieldCustomSingleOption = (propsData: any) => {
    const {
      bankName: selectFieldBankName,
      lastFour: selectFieldLastFour,
      primaryBankStatus,
      contactName: selectFieldContactName,
    } = propsData.data;
    if (!selectFieldBankName) {
      return (
        <div
          style={{ display: 'flex', alignItems: 'center', maxHeight: '50px' }}
        >
          <></>
        </div>
      );
    }
    return (
      <div
        style={{ display: 'flex', alignItems: 'center', maxHeight: '50px' }}
      >
        {selectFieldContactName} | <BankLogo bankName={selectFieldBankName} /> **** {selectFieldLastFour} {primaryBankStatus ? '(Primary)' : ''}
      </div>
    );
  };

  const [reactFundingResultsOptions, setReactFundingResultOptions] = useState([]);

  useEffect(() => {
    if (!fundingResult || fundingResult.legnth === 0) return;
    setReactFundingResultOptions(() => (
      [{
        label: 'New Funding Source',
        value: null,
        issuerBank: null,
        primaryBankStatus: null,
        contactName: null,
      },
      ...fundingResult.map((item) => {
        const displayDetails = `${item?.contact.name} ${item?.issuerBank.bankName} ${item?.issuerBank.lastFour}`;
        return {
          label: displayDetails,
          value: item?.gid,
          issuerBank: item?.issuerBank,
          primaryBankStatus: item?.contact?.primary,
          contactName: item?.contact?.name,
        };
      }),
      ]
    ));
  }, [fundingResult]);

  const selectToAccountFieldCustomOptions = (propData: any) => {
    const {
      data,
      innerRef,
      innerProps,
    } = propData;
    const {
      label,
      issuerBank,
      contactName: selectOptionContactName,
    } = data;
    if (label === 'New Funding Source') {
      return (
        <div
          ref={innerRef}
          {...innerProps}
          style={{
            display: 'flex', alignItems: 'center', padding: '10px', maxHeight: '50px',
          }}
        >
          <Icon type="plus-circle" />&nbsp;New Funding Source
        </div>
      );
    }
    const icon = issuerBank?.businessType === 'INDIVIDUAL'
      ? <img src={IndividualIcon} alt="individual" style={{ width: '15px', height: '15px' }} />
      : <img src={BusinessIcon} alt="business" style={{ width: '15px', height: '15px' }} />;
    const verifiedIcon = data?.status === 'VERIFIED'
      ? <img src={AccountVerifiedIcon} alt="individual" style={{ width: '15px', height: '15px' }} />
      : null;
    const rtpSupportedIcon = (issuerBank?.rtpsupported !== null && issuerBank?.rtpsupported)
      ? <EnabledBadge />
      : null;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          display: 'flex', alignItems: 'center', paddingRight: '10px', paddingLeft: '10px', maxHeight: '50px', gap: '10px',
        }}
      >
        {
          issuerBank && issuerBank.vpa
            ? issuerBank.vpa
            : (issuerBank && issuerBank.bankName && issuerBank.lastFour)
              ? (
                <>
                  {selectOptionContactName} | <BankLogo bankName={issuerBank.bankName} /> ****{issuerBank.lastFour} {icon} {verifiedIcon} {rtpSupportedIcon}
                </>
              )
              : issuerBank && issuerBank.bankName
                ? (
                  <>
                    <BankLogo bankName={issuerBank.bankName} /> {icon} {verifiedIcon} {rtpSupportedIcon}
                  </>
                )
                : (
                  <>
                    {selectOptionContactName} | ****{issuerBank.lastFour} {icon} {verifiedIcon} {rtpSupportedIcon}
                  </>
                )
        }
      </div>
    );
  };

  const selectToAccountFieldCustomSingleOption = (dataprops: any) => {
    const {
      // label,
      issuerBank,
      contactName: selectFieldContactName,
      addNewFundingSourceStatus,
      status,
    } = dataprops.data;
    if (addNewFundingSourceStatus) {
      return (
        <div
          style={{
            display: 'flex', alignItems: 'center', padding: '10px', maxHeight: '50px',
          }}
        >
          <Icon type="plus-circle" />&nbsp;New Funding Source
        </div>
      );
    }
    if (!issuerBank.bankName) {
      return (
        <div
          style={{ display: 'flex', alignItems: 'center', maxHeight: '50px' }}
        >
          <></>
        </div>
      );
    }
    const icon = issuerBank?.businessType === 'INDIVIDUAL'
      ? <img src={IndividualIcon} alt="individual" style={{ width: '15px', height: '15px' }} />
      : <img src={BusinessIcon} alt="business" style={{ width: '15px', height: '15px' }} />;
    const verifiedIcon = status && status === 'VERIFIED'
      ? <img src={AccountVerifiedIcon} alt="individual" style={{ width: '15px', height: '15px' }} />
      : null;
    const rtpSupportedIcon = (issuerBank?.rtpsupported !== null && issuerBank?.rtpsupported)
      ? <EnabledBadge />
      : null;
    return (
      <div
        style={{
          display: 'flex', alignItems: 'center', paddingRight: '10px', paddingLeft: '10px', maxHeight: '50px', gap: '10px',
        }}
      >
        {
          issuerBank && issuerBank.vpa
            ? issuerBank.vpa
            : (issuerBank && issuerBank.bankName && issuerBank.lastFour)
              ? (
                <>
                  {selectFieldContactName} | <BankLogo bankName={issuerBank.bankName} /> ****{issuerBank.lastFour} {icon} {verifiedIcon} {rtpSupportedIcon}
                </>
              )
              : issuerBank && issuerBank.bankName
                ? (
                  <>
                    <BankLogo bankName={issuerBank.bankName} /> {icon} {verifiedIcon} {rtpSupportedIcon}
                  </>
                )
                : (
                  <>
                    {selectFieldContactName} | ****{issuerBank.lastFour} {icon} {verifiedIcon} {rtpSupportedIcon}
                  </>
                )
        }
      </div>
    );
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: 'white',
      cursor: 'pointer',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#bfbfbf',
    }),
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      width="500px"
      footer={[
        <SpButton key="1" onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton key="2" onClick={handlePay} loading={otpVerifyLoading} disabled={otpVerifyLoading}>Pay</SpButton>,
      ]}
      className="p-3"
      title="Payment Confirmation"
    >
      <div className="px-5 mt-2">
        <div className="mb-3">
          <label htmlFor=""><SpH5>From</SpH5></label>
          {/* <AutoComplete
            placeholder="Select Account"
            showSearch
            className="w-100"
            onSearch={searchContact}
            dataSource={manageAccountInfo.map((item, key) => {
              const bankInfo = `${item.issuerBank.bankName} **** ${item.issuerBank.lastFour}`;
              const displayDetails = item?.contact?.primary ? `${bankInfo} (Primary)` : bankInfo;
              return (
                <Option key={key} value={item.gid} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  {displayDetails}
                </Option>
              );
            })}
            style={{ height: '40px' }}
            value={contactName}
            onSelect={e => updateContact(e)}
          /> */}
          <ReactSelect
            options={reactContactOptions}
            className="w-100"
            maxMenuHeight={250}
            value={payerFundingSourceGid ? {
              label: `${contactName} ${payerFundingSourceBankInfo.bankName} ${payerFundingSourceBankInfo.lastFour} ${payerFundingSourceBankInfo.primaryBankStatus}`,
              value: payerFundingSourceGid,
              ...payerFundingSourceBankInfo,
            } : null}
            onChange={updateContact}
            styles={customStyles}
            components={{ Option: selectFieldCustomOptions, SingleValue: selectFieldCustomSingleOption, DropdownIndicator: () => null }}
            isOptionSelected={(option, value) => option.value === value.value}
            placeholder="Select Account"
          />
          <SpError>
            {simpleValidator.current.message('account', contactName, 'required')}
          </SpError>

        </div>
        <div className="mt-2 mb-3 ">
          <label htmlFor=""><SpH5>To Account</SpH5></label>

          {/* <Select
            placeholder="Select Funding Source"
            className="w-100"
            style={{ height: '40px' }}
            value={fundingSourceName}
            onSelect={e => updateFunding(e)}
          >
            <Option key="1" value="New Funding Source">
              <Icon type="plus-circle" />&nbsp;New Funding Source
            </Option>
            {fundingResult && fundingResult.map((item) => {
              const { issuerBank } = item;
              const icon = issuerBank?.businessType === 'INDIVIDUAL'
                ? <img src={IndividualIcon} alt="individual" style={{ width: '15px', height: '15px' }} />
                : <img src={BusinessIcon} alt="business" style={{ width: '15px', height: '15px' }} />;
              const verifiedIcon = item?status === 'VERIFIED'
                ? <img src={AccountVerifiedIcon} alt="individual" style={{ width: '15px', height: '15px' }} />
                : null;
              const rtpSupportedIcon = (issuerBank?.rtpsupported !== null && issuerBank?.rtpsupported)
                ? <EnabledBadge />
                : null;
              return (
                <Option key={item.gid} value={item.gid}>
                  {
                    item.issuerBank && item.issuerBank.vpa
                      ? item.issuerBank.vpa
                      : (item.issuerBank && item.issuerBank.bankName && item.issuerBank.lastFour)
                        ? (
                          <>
                            {item?.contact?.name} | {item.issuerBank.bankName} ****{item.issuerBank.lastFour} {icon} {verifiedIcon} {rtpSupportedIcon}
                          </>
                        )
                        : item.issuerBank && item.issuerBank.bankName
                          ? (
                            <>
                              {item.issuerBank.bankName} {icon} {verifiedIcon} {rtpSupportedIcon}
                            </>
                          )
                          : (
                            <>
                              {item?.contact?.name} | ****{item.issuerBank.lastFour} {icon} {verifiedIcon} {rtpSupportedIcon}
                            </>
                          )
                  }
                </Option>
              );
            })}
          </Select> */}
          {fundingResult
            && fundingResult.length > 0
            && fundingSourceBankInfo?.issuerBank?.bankName
            ? (
              <ReactSelect
                options={reactFundingResultsOptions}
                className="w-100"
                maxMenuHeight={250}
                value={fundingSourceGid ? {
                  label: `${fundingSourceName} ${fundingSourceBankInfo.issuerBank.bankName} ${fundingSourceBankInfo.issuerBank.lastFour}`,
                  value: fundingSourceGid,
                  addNewFundingSourceStatus: fundingSourceName === 'New Funding Source',
                  ...fundingSourceBankInfo,
                } : null}
                onChange={updateFunding}
                styles={customStyles}
                components={{ Option: selectToAccountFieldCustomOptions, SingleValue: selectToAccountFieldCustomSingleOption, DropdownIndicator: () => null }}
                isOptionSelected={(option, value) => option.value === value.value}
                placeholder="Select Account"
              />
            ) : null}
          <SpError>
            {simpleValidator.current.message('funding Source Name', fundingSourceName, 'required')}
          </SpError>
        </div>
        {fundingSourceName === 'New Funding Source' && (
          <>
            <div className="mb-3">
              <label htmlFor=""><SpH5>Account Holder Name</SpH5></label>
              <Input
                placeholder="Name"
                value={accountHolderName}
                disabled={disableFunding}
                onChange={(e) => setAccountHolderName(e.currentTarget.value)}
              />
              <SpError>
                {simpleValidator.current.message('Account Holder Name', accountHolderName, 'required')}
              </SpError>
            </div>
            {
              (transferDetailsData && (transferDetailsData.transferType === BENE_TYPES.UPI)) ? (
                <>
                  <div>
                    <label htmlFor=""><SpH5>UPI Id</SpH5></label>
                    <Input
                      placeholder="Enter UPI Id"
                      value={upiId}
                      disabled={disableFunding}
                      onChange={(e) => setUpiId(e.currentTarget.value)}
                    />
                    <SpError>
                      {simpleValidator.current.message('upi id', upiId, 'required|upiNumber')}
                    </SpError>
                  </div>
                </>
              ) : (
                <>
                  <div className="mb-3">
                    <label htmlFor=""><SpH5>Account Number</SpH5></label>
                    <Input
                      placeholder="Account Number"
                      value={disableFunding ? `****** ${accountNumber}` : accountNumber}
                      disabled={disableFunding}
                      onBlur={() => setAccountNumber(accountNumber.trim())}
                      onChange={(e) => setAccountNumber(e.currentTarget.value)}
                    />
                    {
                      disableFunding ? (
                        <SpError>
                          {simpleValidator.current.message('account number', accountNumber, 'required')}
                        </SpError>
                      ) : (
                        <SpError>
                          {simpleValidator.current.message('account number', accountNumber, 'required|accountNumber')}
                        </SpError>
                      )
                    }
                  </div>
                  {
                    !isIndia && (
                      <div className="mb-3">
                        <label htmlFor=""><SpH5>Routing Number</SpH5></label>
                        <Input
                          placeholder="Routing Number"
                          disabled={disableFunding}
                          value={routingNumber}
                          onBlur={() => setRoutingNumber(routingNumber.trim())}
                          onChange={(e) => setRoutingNumber(e.currentTarget.value)}
                        />
                        <SpError>
                          {simpleValidator.current.message('routing number', routingNumber, 'required|bankRoutingNumber')}
                        </SpError>
                      </div>
                    )
                  }
                  {
                    isIndia && (
                      <div className="mb-3">
                        <label htmlFor=""><SpH5>IFSC Number</SpH5></label>
                        <Input
                          placeholder="IFSC Number"
                          disabled={disableFunding}
                          value={routingNumber}
                          onBlur={() => setRoutingNumber(routingNumber.trim())}
                          onChange={(e) => setRoutingNumber((e.currentTarget.value).toUpperCase())}
                        />
                        <SpError>
                          {simpleValidator.current.message('ifsc number', routingNumber, 'required')}
                        </SpError>
                      </div>
                    )
                  }
                  <div className="mb-3">
                    <label htmlFor=""><SpH5>Bank Name</SpH5></label>
                    <Input
                      placeholder="Bank Name"
                      disabled={disableFunding}
                      value={bankName}
                      onChange={(e) => setBankName(e.currentTarget.value)}
                    />
                    {
                      !disableFunding && (
                        <SpError>
                          {simpleValidator.current.message('bank name', bankName, 'required|bankName')}
                        </SpError>
                      )
                    }
                  </div>
                  <div>
                    <label htmlFor=""><SpH5>Account Type</SpH5></label>
                    {
                      isIndia && (
                        <Select
                          className="w-100"
                          showSearch
                          disabled={disableFunding}
                          value={accountType}
                          onChange={(value) => {
                            setAccountType(value);
                          }}
                        >
                          <Option key={1} value="CURRENT">CURRENT ACCOUNT</Option>
                          <Option key={2} value="SAVINGS">SAVINGS</Option>
                        </Select>
                      )
                    }
                    {
                      !isIndia && (
                        <Select
                          className="w-100"
                          showSearch
                          disabled={disableFunding}
                          value={accountType}
                          onChange={(value) => {
                            setAccountType(value);
                          }}
                        >
                          <Option key={1} value="CHECKING">CHECKING</Option>
                          <Option key={2} value="SAVINGS">SAVINGS</Option>
                        </Select>
                      )
                    }
                    <SpError>
                      {simpleValidator.current.message('account type', accountType, 'required')}
                    </SpError>
                  </div>
                  <div className="mb-3 mt-3">
                    <label htmlFor=""><SpH5>Business Type</SpH5></label>
                    <Select
                      className="w-100"
                      showSearch
                      value={businessType}
                      onChange={(value) => {
                        setBusinessType(value);
                      }}
                    >
                      <Option key={1} value="INDIVIDUAL">INDIVIDUAL</Option>
                      <Option key={2} value="BUSINESS">BUSINESS</Option>
                    </Select>
                    <SpError>
                      {simpleValidator.current.message('business type', businessType, 'required')}
                    </SpError>
                  </div>
                </>
              )
            }
          </>
        )}
        <div style={{ border: '1px solid #C7C7C7', padding: '10px', borderRadius: '6px' }} className="mt-2">
          <div className="mb-3">
            <Row justify="start">
              <Col>
                <SpH5>Invoice Amount</SpH5>
              </Col>
              <Col>
                <SpText>{(totalAmount) ? `${prefix} ${totalAmount}` : <>&#8211;</>}</SpText>
              </Col>
            </Row>
          </div>
          {
            exchangeEntity && exchangeEntity?.amount ? (
              <>
                <div className="mb-3">
                  <Row justify="start">
                    <Col>
                      <SpH5>Exchange Rate</SpH5>
                    </Col>
                    <Col>
                      <SpText>
                        {(exchangeRate) ? `₹ ${(exchangeRate)}` : <>&#8211;</>}
                      </SpText>
                    </Col>
                  </Row>
                </div>
                <div className="mb-3">
                  <Row justify="start">
                    <Col>
                      <SpH5>Converted Amount</SpH5>
                    </Col>
                    <Col>
                      <SpText>
                        {(convertedAmount) ? `₹ ${(convertedAmount)}` : <>&#8211;</>}
                      </SpText>
                    </Col>
                  </Row>
                </div>
                <div className="mb-3">
                  <Row justify="start">
                    <Col>
                      <SpH5>Bank account (ACH) fee</SpH5>
                    </Col>
                    <Col>
                      <SpText>
                        {(exchangeFee || tax) ? `${prefix} ${(exchangeFee + tax)}` : <>&#8211;</>}
                      </SpText>
                    </Col>
                  </Row>
                </div>
                <div className="mb-3">
                  <Row justify="start">
                    <Col>
                      <SpH5>
                        Low volume fee
                        <Tooltip placement="right" title={<span style={{ fontSize: '11px' }}>A fee charged if your transaction volume falls below the minimum threshold set by the platform.</span>}>
                          <Icon
                            style={{
                              fontSize: '12px',
                              marginLeft: '3px',
                              marginBottom: '3px',
                              cursor: 'pointer',
                            }}
                            component={informationIcon}
                          />
                        </Tooltip>
                      </SpH5>
                    </Col>
                    <Col>
                      <SpText>
                        {`${prefix} ${lowVolumeFee}`}
                      </SpText>
                    </Col>
                  </Row>
                </div>
                <hr style={{ margin: '10px 0', border: '0.5px solid #ccc' }} />

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Row>
                    <Col>
                      <SpH5>Total fees</SpH5>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <SpH5>
                        {`${prefix} ${totalFee}`}
                      </SpH5>
                    </Col>
                  </Row>
                </div>
                <hr style={{ margin: '10px 0', border: '0.5px solid #ccc' }} />
              </>
            ) : (<></>)
          }
          <div className="mb-3">
            <Row justify="start">
              <Col>
                <SpH5>Invoice No.</SpH5>
              </Col>
              <Col>
                <SpText>{(invoiceDetails && invoiceDetails.invoiceNumber) || <>&#8211;</>}</SpText>
              </Col>
            </Row>
          </div>
          <div>
            <Row justify="start">
              <Col>
                <SpH5>Contact</SpH5>
              </Col>
              <Col>
                <SpText>
                  {fundingSourceName ?? <>&#8211;</>}
                </SpText>
              </Col>
            </Row>
          </div>
        </div>
        {
          showOtpScreen && transferSettings && (
            <div style={{
              display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center',
            }}
            >
              {
                error && (
                  <div>
                    <SpError>
                      Please provide the OTP
                    </SpError>
                  </div>
                )
              }
              <img src={Lock} alt="Lock" style={{ marginTop: '3px', width: '25px' }} />
              <SpH5 style={{ marginTop: '3px' }}>Enter Code</SpH5>
              <SpText>Enter the code sent to {transferSettings && transferSettings.approvalEmail}</SpText>
              <div className="mt-2">
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderSeparator={<span style={{ width: '8px' }} />}
                  inputType="password"
                  inputStyle={{
                    border: '1px solid',
                    borderRadius: '8px',
                    width: '54px',
                    height: '54px',
                    fontSize: '12px',
                    color: '#000',
                    fontWeight: '400',
                    caretColor: 'blue',
                  }}
                  // eslint-disable-next-line no-shadow
                  renderInput={(props) => <input {...props} />}
                />
              </div>
            </div>
          )
        }
      </div>
    </Modal>
  );
};

// $FlowFixMe
const mapStateToProps = (state) => ({
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  test: state.account.test,
  fundingSearchList: state.transfers.searchFundingList,
  manageAccountsList: state.manageAccounts.content,


});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  searchFundingSource: param => dispatch(transfersActions.searchFundingSource({
    payload: param,
  })),
  fetchSelfAccounts: param => dispatch(manageAccountActions.fetchSelfAccounts({
    payload: param,
  })),
  fetchVendorInvoiceDetails: gid => dispatch(vendorInvoiceDetailsActions.fetchVendorInvoiceDetails({
    payload: gid,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPaymentModal);
